/* eslint-disable react/no-danger */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MetaTags from 'react-meta-tags';
import * as blogActions from '../../actions/blogActions';
import * as trackActions from '../../actions/trackActions';
import * as videoActions from '../../actions/videoActions';
import Loading from '../common/Loading';
import ShareService from '../../services/shareService.js';
import urls from '../../constants/urls.js';
import articleTypes from '../../constants/articleTypes';
import ReviewContent from './ReviewContent';
import InterviewContent from './InterviewContent';
import ContentShare from '../common/ContentShare';
import TrackService from '../../services/trackService';
import VideoService from '../../services/videoService';
import HearMeItem from '../profile/HearMeItem';
import VideoItem from '../common/VideoItem';
import Advert from '../common/Advert';
import NotFound from '../common/NotFound';
import startsWith from 'lodash/startsWith';

class DiscoverArticlePage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getTitle = this.getTitle.bind(this);
        this.getMetaDescription = this.getMetaDescription.bind(this);
        this.getArticle = this.getArticle.bind(this);
        this.getImageShareUrl = this.getImageShareUrl.bind(this);
        this.getRaw = this.getRaw.bind(this);
        this.getTrack = this.getTrack.bind(this);
        this.getVideo = this.getVideo.bind(this);
        this.addLinks = this.addLinks.bind(this);
        this.format = this.format.bind(this);
        this.navigate = this.navigate.bind(this);
        this.state = {
            track: null,
            video: null
        };
    }

    componentWillMount() {        
        this.getArticle();
    }

    componentDidMount() {       
        this.getTrack();
        this.getVideo();
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.props.match.params.link != nextProps.match.params.link) {
            this.setState({
                resource: null
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        
        if(this.props.match.params.link != prevProps.match.params.link) {
            this.getArticle();
        }
        if(this.props.article && !prevProps.article) {
            this.getTrack();
            this.getVideo();
        }
    }

    getArticle() {
        this.props.actions.getArticle(this.props.match.params.link);
    }

    getTrack() {
        if(this.props.article && this.props.article.Content.Closing.ResourceID && this.props.article.Content.Closing.ResourceType === 'Music') {
            TrackService.getTrack(this.props.article.Content.Closing.ResourceID)
            .then(track => {
                if(track) {                           
                    this.setState({
                        track
                    });
                }
            })
            .catch(error => {
                //do nothing
            });
        }
    }

    getVideo() {
        if(this.props.article && this.props.article.Content.Closing.ResourceID && this.props.article.Content.Closing.ResourceType === 'Video') {
            VideoService.getVideo(this.props.article.Content.Closing.ResourceID)
            .then(video => {
                if(video) {                           
                    this.setState({
                        video
                    });
                }
            })
            .catch(error => {
                //do nothing
            });
        }
    }

    getTitle() {
        let title = '';
        if(this.props.article) {
            title = `${this.props.article.Title} - Discover - LoudUp`;
        }        
        return title;
    }

    getImageShareUrl() {
        let imageShareUrl;
        if(this.props.article) {
            if(this.props.article.ImageUrl) {
                imageShareUrl = `${urls.USER_IMAGES_BASE_URL}${this.props.article.ImageUrl}`;
            }
            else {
                imageShareUrl = ShareService.getAbsoluteUrl(require('../../images/logo_loudup_mini.png'));
            }
        }
        return imageShareUrl;
    }

    getMetaDescription() {
        return this.props.article ? this.props.article.Intro : '';
    }

    getRaw(text) {
        return {__html: text};
    }

    addLinks(text, links) {
        let args = [];
        for(let i = 0; i < links.length; i++) {
            const link = links[i];
            if(link.IsInternal) {
                args.push(`<a href="${link.Url}">${link.AnchorText}</a>`);
            }
            else {
                args.push(`<a href="${link.Url}" target="_blank" ${link.Follow ? 'rel="nofollow"' : ''}>${link.AnchorText}</a>`);
            }
        }
        return this.format(text, args);
    }

    format(text, args) {
        return text.replace(/{(\d+)}/g, function(match, number) { 
            return typeof args[number] != 'undefined'
                ? args[number] 
                : match
            ;
        });
    }

    navigate(event) {
        if(event.target.tagName.toLowerCase() === 'a' && event.target.host === window.location.host) {
            //it's an internal link, use the react routing
            event.preventDefault();
            this.props.history.push(event.target.pathname);
        }
    }

    render() {
        const title = this.getTitle();
        const description = this.getMetaDescription();
        const url = ShareService.getAbsoluteUrl(this.props.match.url);
        const imageShareUrl = this.getImageShareUrl();
        const article = this.props.article;
        const isReview = article && article.Title.indexOf('Review') > -1;
        return (
            
            <div className="main blog">     
                <MetaTags>
                    <title>{title}</title>            
                    <meta id="description" name="description" content={description} />  
                    <meta id="og-url" property="og:url" content={url} />
                    <meta id="og-description" property="og:description" content={description} />
                    <meta id="og-image" property="og:image" content={imageShareUrl} />
                    <meta id="twitter-url" name="twitter:url" content={url} />
                    <meta id="twitter-title" name="twitter:title" content={title} />
                    <meta id="twitter-description" name="twitter:description" content={description} />
                    <meta id="twitter-image" name="twitter:image" content={imageShareUrl} />
                </MetaTags>
                <link href="https://fonts.googleapis.com/css?family=Indie+Flower" rel="stylesheet" type="text/css" />
                <link href="https://fonts.googleapis.com/css?family=Open+Sans" rel="stylesheet" type="text/css" />
                <style>{`.attribution {font-size: 0.9em; font-style: italic;}`}</style>
                <style>                
                {`
                    .question {font-weight: bold; padding-bottom:5px; display:block}
                    .respondent {font-weight: bold;}
                    .closing {font-weight: bold;}
                    p.attribution span {font-size: 0.85em; font-style:italic;}
                    p.closing {padding-top:15px;}
                    p.attribution {padding-top:20px;}
                `}
                </style>
                <div className="main blog">
                    <div className="container">
                        <div className="block-inner">
                            <div className="blog-content">
                            {
                                article ?
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div id="blogSummaryContainer">
                                                <div className="back">
                                                    <Link to="/Discover" className="btn-back transition">«- Return to Discover</Link>
                                                </div>
                                                <div className="blogcol">
                                                    <article className="blogpost">
                                                        <header>
                                                            <h1>
                                                                <a href={null} className="transition">{article.Title}</a>
                                                            </h1>
                                                            <p className="spec">
                                                                <span className="sections">
                                                                {
                                                                    article.Sections.map(section =>
                                                                        <a key={section} href={null} className="sect transition">{section}</a>
                                                                    )
                                                                }
                                                                </span>
                                                                <em>By <Link to={`/${article.AuthorUsername}`}>{article.AuthorDisplayName}</Link></em>
                                                            </p>
                                                        </header>
                                                        <div id="interview" className="blogbody">
                                                            {
                                                                article.ImageUrl ?
                                                                    <div className="blogimg">
                                                                            <img className="img-responsive" src={`${urls.USER_IMAGES_BASE_URL}${article.ImageUrl}?width=527&maxheight=420&quality=80&mode=crop&scale=both&format=jpg`} alt={article.Title} />                                                                        
                                                                    </div>
                                                                    : null
                                                            }
                                                            {
                                                                isReview ?
                                                                    <ReviewContent content={article.Content} getRaw={this.getRaw} />
                                                                :   <InterviewContent content={article.Content} getRaw={this.getRaw} addLinks={this.addLinks} navigate={this.navigate} />
                                                            }                                                           
                                                            {
                                                                article.Content.Closing ?
                                                                <p className="closing">
                                                                    {
                                                                        article.Content.Closing.Text ?
                                                                            article.Content.Closing.Links && article.Content.Closing.Links.length ?
                                                                                <span onClick={this.navigate} dangerouslySetInnerHTML={this.getRaw(this.addLinks(article.Content.Closing.Text, article.Content.Closing.Links))} />
                                                                            :
                                                                                <span dangerouslySetInnerHTML={this.getRaw(article.Content.Closing.Text)} />
                                                                        : null
                                                                    }
                                                                    {
                                                                        this.state.track ?
                                                                        <div id="ulHearMe">
                                                                            <HearMeItem track={this.state.track.Track} roleID={this.state.track.RoleID} actions={this.props.actions} />
                                                                        </div>
                                                                        : null
                                                                    }
                                                                    {
                                                                        this.state.video ?
                                                                        <ul id="ulHearMe" className="list-unstyled itemlist hearlist">
                                                                            <VideoItem video={this.state.video.Video} actions={this.props.actions} roleID={this.state.video.RoleID} />
                                                                        </ul>
                                                                        : null
                                                                    }
                                                                </p>
                                                                : null
                                                                }
                                                            {
                                                                article.Content.AttributionText ?
                                                                <p className="attribution">
                                                                    <span dangerouslySetInnerHTML={this.getRaw(article.Content.AttributionText)} />
                                                                </p>
                                                                : null
                                                            }
                                                            <br />
                                                        </div>
                                                        <ContentShare absoluteUrl={url} relativeUrl={this.props.match.url} shareCount={article.ShareCount} articleType="Discover" showMailingList contentType={isReview ? 'review' : 'interview'} showText />
                                                        <br />
                                                        {
                                                            article.Tags && article.Tags.length ?
                                                            <React.Fragment>
                                                                <br />
                                                                <div className="arttags">
                                                                    <svg className="icon icn-tag transition">
                                                                        <use xlinkHref="#icn-tag" />
                                                                    </svg>
                                                                    {
                                                                        article.Tags.map(tag =>
                                                                            <a key={tag} href={null} className="tag transition">{tag}</a>
                                                                        )
                                                                    }
                                                                </div>
                                                            </React.Fragment>
                                                            : null
                                                        }
                                                        <br />
                                                    </article>
                                                    {
                                                        article.RelatedPosts && article.RelatedPosts.length ?
                                                            <div className="blogrelated">
                                                                <h2>Related posts</h2>
                                                                {
                                                                    article.RelatedPosts.map(item =>
                                                                        <article key={item.ID} className="blogpost">
                                                                            <header className="transition">
                                                                                <div className="imgbox">
                                                                                    <a href={null}>
                                                                                    {
                                                                                        item.imageUrl ?
                                                                                            <img src={`${urls.USER_IMAGES_BASE_URL}${item.ImageUrl}?width=100&aspectw=1.75&quality=80&mode=crop&scale=both&format=jpg`} alt={item.Title} />
                                                                                        :
                                                                                            <img src={require('../../images/relatedblog-blank.png')} alt={item.Title} />
                                                                                    
                                                                                    }
                                                                                    </a>
                                                                                </div>
                                                                                <h1>
                                                                                    <Link to={`/${this.props.articleType === articleTypes.general ? 'blog' : 'unsigned'}/${item.Link}`} className="transition">{item.Title}</Link>
                                                                                </h1>
                                                                                <p className="spec">
                                                                                    <span className="sections">
                                                                                    {
                                                                                        item.Sections.map(section =>
                                                                                            <a key={section} href={null} className="sect transition">{section}</a>
                                                                                        )
                                                                                    }
                                                                                    </span>
                                                                                    <br />
                                                                                    <span style={{fontSize: '0.9em'}}><em>{item.Intro}</em></span>
                                                                                </p>
                                                                            </header>
                                                                        </article>
                                                                    )
                                                                }
                                                            </div>
                                                            : null
                                                    }


                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="content-side-2" style={{paddingTop: ':40px'}}>
                                                <Advert adType="Square" />
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    this.props.articleLoadingStatus && this.props.articleLoadingStatus.status == 'LOADING' ? <Loading />  : <NotFound />
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

DiscoverArticlePage.propTypes = {
    articleType: PropTypes.string.isRequired,
    article: PropTypes.object,
    actions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    articleLoadingStatus: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let articleType = '';
    const path = ownProps.match.path;
    if(startsWith(path, '/blog')) {
        articleType = articleTypes.general;
    } 
    else if(startsWith(path, '/unsigned')) {
        articleType = articleTypes.unsigned;
    } 
    else {
        articleType = articleTypes.discover;
    }
    let article = null;
    if(state.blog.article && state.blog.article.Link.toLowerCase() === ownProps.match.params.link.toLowerCase()) {
        article = state.blog.article;
    }
    return { articleType, article, articleLoadingStatus: state.blog.articleLoadingStatus };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, blogActions, trackActions, videoActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscoverArticlePage);
